import React from "react";
import { useState, useMemo } from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import CartOffers from "./CartOffers";
import Sheet from "@mui/joy/Sheet";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import { addTip } from "../../store/actions/cartActions";
import { hexToCSSFilter } from "hex-to-css-filter";
import CouponImg from "../../assets/img/Coupon.png";
import { computeCheckoutTotals } from "../../utils/order_helper";

import { connect, useSelector } from "react-redux";

function CartAmount(props) {
  const cartProps = useSelector(state => state.cartReducer) || {};
  const reducer = useSelector(state => state.customerReducer) || {};
  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  
  const { addedItems, storeOffer } = cartProps || {};
  const { customer } = reducer || {};
  const storeInfo = sessionReducer?.store_details;
  const storeInfoConfig = sessionReducer?.store_config;
  const navigate = useNavigate();
  // const [specialInst, setSpecialInst] = useState(false);
  // const [specialInstText, setSpecialInstText] = useState(null);
  const [open, setOpen] = useState(false);

  const engineTotals = useMemo(() => {
    if (!addedItems || addedItems.length === 0) return null;
    try {
      return computeCheckoutTotals(addedItems, {
        orderType:         cartProps?.orderType?.order?.order_type,
        storeId:           storeInfo?.store_id,
        paymentOption:     cartProps?.selectedTender,
        storeConfig:       storeInfoConfig,
        tip:               cartProps?.tip || 0,
        applyCurrentOffer: true,
      });
    } catch (e) {
      console.error("[CartAmount] engine failed, falling back to reducer values", e);
      return null;
    }
    // engineDiscount is read via store.getState() inside computeCheckoutTotals
    // (applyCurrentOffer:true) — declare it here so the memo re-runs on offer
    // apply/remove.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addedItems, cartProps?.tip, cartProps?.selectedTender, cartProps?.orderType, cartProps?.engineDiscount, storeInfo?.store_id, storeInfoConfig]);
  // All display values come from the engine (offer replay + tip fold-in are
  // handled inside computeCheckoutTotals via applyCurrentOffer:true).
  const totals = engineTotals ?? {};
  const displaySubTotalVal = totals.sub_total ?? 0;
  const displayTax = totals.total_item_tax ?? 0;
  const displayDiscount = totals.total_discount ?? 0;
  const displayTotal = totals.transaction_grand_amount ?? 0;

  const last_order = reducer?.last_order;
  const activeOrders = last_order?.order_details?.filter(
    (order) => {
      const status = (order?.order_status || "").toUpperCase();
      const state = (order?.order_state || "").toUpperCase();
      const isClosed = status === "CLOSE" || status === "CLOSED" || status === "COMPLETED" || status === "COMPLETE" || status === "CANCELLED" ||
                       state === "CLOSE" || state === "CLOSED" || state === "COMPLETED" || state === "COMPLETE" || state === "CANCELLED";
      if (isClosed) return false;
      if (!order?.date_time) return false;
      
      const dateStr = (order?.business_date || order?.date_time || order?.created_at || "").replace(" ", "T");
      const orderDateOnly = dateStr.slice(0, 10);
      const businessDate = props.sessionReducer?.store_details?.business_date;
      if (businessDate) {
        return orderDateOnly === businessDate.slice(0, 10);
      }
      
      const orderDate = new Date(dateStr);
      const today = new Date();
      return (
        orderDate.getDate() === today.getDate() &&
        orderDate.getMonth() === today.getMonth() &&
        orderDate.getFullYear() === today.getFullYear()
      );
    }
  ) || [];
  const hasActiveOrders = activeOrders.length > 0;
 
 
    let storeCurrency = storeInfo?.store_currency;
const [currency, setCurrency] = useState(() => {
  switch (storeCurrency) {
    case "INR":
      return "₹";
    case "USD":
      return "$";
    case "CAD":
      return "$";
    case "OMR":
      return "OMR ";
    case "AED":
      return "AED ";
    default:
      return "$"; // default to dollar if no match
  }
});



  let tip_enable= storeInfoConfig?.web_ordering_setting?.tip_option_qr;
  

  const [value, setValue] = useState(0);

  const handleChange = (event) => {
    if(event.target.value=="No Tip"){
    setValue(event.target.value);
    props.addTip(parseFloat(0.00));
    }else{
          setValue(event.target.value);
    props.addTip(parseFloat(event.target.value));
    }
  };

  const Tip = () => {
    return (
      <Grid container style={{ paddingBottom: "1rem" }}>
        <Grid container justifyContent="center" xs={12} sm={12} md={12} lg={12}>
          <Grid item xs={3} sm={3} md={3} lg={3}>
            <Typography
              style={{
                padding: "0.5rem 0rem",
                textAlign: "left",
                fontWeight: "bold",
              }}
            >
              Tip
            </Typography>
          </Grid>

          <Grid
            item
            xs={9}
            sm={9}
            md={9}
            lg={9}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <RadioGroup
              sx={{ gap: 1.5, display: "flex", flexDirection: "row" }}
              value={value}
              onChange={handleChange}
            >
              {[10, 15, 20, "No Tip"].map((e) => {
                const displayLabel = typeof e === "number" ? `${currency} ${e}` : e;
                return (
                  <Sheet
                    key={e}
                    sx={{
                      p: 1,
                      borderRadius: "md",
                      boxShadow: "sm",
                    }}
                  >
                    <Radio
                      label={displayLabel}
                      overlay
                      size="small"
                      value={e}
                      disableIcon
                      slotProps={{
                        label: ({ checked }) => ({
                          sx: {
                            fontSize: "sm",
                            color: checked ? "black" : "black",
                          },
                        }),
                        action: ({ checked }) => ({
                          sx: (theme) => ({
                            ...(checked && {
                              "--variant-borderWidth": "2px",
                              "&&": {
                                borderColor: "#dee7ee",
                                background: "#dee7ee",
                              },
                            }),
                          }),
                        }),
                      }}
                    />
                  </Sheet>
                );
              })}
            </RadioGroup>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Grid
        style={{
          margin: "1.3rem",
          paddingRight: "6%",
          paddingLeft: "3%",
          paddingTop: "2%",
          paddingBottom: "3%",
          marginBottom: hasActiveOrders ? "7rem" : "5rem",
          borderRadius: "8px",
          backgroundColor: "#ffffff",
          boxShadow: "#0000001F 0px 0px 4px 0px",
        }}
      >

        <CartOffers
          {...props}
          {...{
            open,
            setOpen,
            currency,
            addedItems,
            storeOffer,
            cartProps,
            storeInfo,
          }}
        />
        {storeOffer?.length ? (
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginBottom: "1rem" }}
          >
            <button
              onClick={() => setOpen(true)}
              style={{
                width: "100%",
                padding: "1rem 1rem",
                borderRadius: "8px",
                border: `1.5px solid ${storeInfoConfig?.general_config?.primary_color || "#3159A6"}`,
                background: "#ffffff",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "0.5rem",
              }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <img
                  src={CouponImg}
                  alt="coupon"
                  style={{
                    width: "22px",
                    height: "22px",
                    objectFit: "contain",
                    filter: `brightness(0) ${
                      hexToCSSFilter(
                        storeInfoConfig?.general_config?.primary_color || "#000000"
                      ).filter
                    }`,
                  }}
                />
                <span
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "600",
                    color: "#333333",
                  }}
                >
                  {displayDiscount ? "Change / Remove Offer" : "Apply Coupon"}
                </span>
              </span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 18l6-6-6-6"
                  stroke={storeInfoConfig?.general_config?.primary_color || "#3159A6"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </Grid>
        ) : ""}
{tip_enable ?
        <Tip />:""}        <Grid container xs={12} sm={12} md={12} lg={12}>
          <Grid item xs={8} sm={8} md={8} lg={8}>
            <Typography style={{ textAlign: "left",fontWeight: "600" }}>Items Total</Typography>
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <Typography style={{ textAlign: "right",fontWeight: "600" }}>
              {currency}{" "}
              {displaySubTotalVal.toFixed(2)}
            </Typography>
          </Grid>

          {cartProps?.tip ? (
            <>
              <Grid item xs={8} sm={8} md={8} lg={8}>
                <Typography style={{ textAlign: "left",fontWeight: "600" }}>Tip</Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <Typography style={{ textAlign: "right",fontWeight: "600" }}>
                  {currency}{" "}
                  {(cartProps.tip ?? 0).toFixed(2)}
                </Typography>
              </Grid>
            </>
          ) : (
            ""
          )}

          {displayDiscount ? (
            <>
              <Grid item xs={8} sm={8} md={8} lg={8}>
                <Typography style={{ textAlign: "left",fontWeight: "600" }}>Discount</Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <Typography style={{ textAlign: "right",fontWeight: "600" }}>
                  -{currency}{" "}
                  {displayDiscount.toFixed(2)}
                </Typography>
              </Grid>
            </>
          ) : (
            ""
          )}
          {cartProps?.chargesTitle && (
            <>
              <Grid item xs={8} sm={8} md={8} lg={8}>
                <Typography style={{ textAlign: "left",fontWeight: "600" }}>
                  {cartProps?.chargesTitle}
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <Typography style={{ textAlign: "right",fontWeight: "600" }}>
                  {currency}{" "}
                  {(cartProps.chargeValue ?? 0).toFixed(2)}
                </Typography>
              </Grid>
            </>
          )}

          <>
            <Grid item xs={8} sm={8} md={8} lg={8}>
              <Typography style={{ textAlign: "left", fontWeight: "600" }}>Tax</Typography>
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <Typography style={{ textAlign: "right", fontWeight: "600" }}>
                {currency}{" "}
                {displayTax.toFixed(2)}
              </Typography>
            </Grid>
          </>
        </Grid>
        <Grid
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            padding: "1rem 0rem",
            // borderTop: "1px solid #A8A8A8",
          }}
        >
          <Divider></Divider>
        </Grid>
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ padding: "0rem 0rem" }}
        >
          <Grid item xs={8} sm={8} md={8} lg={8}>
            <Typography style={{ textAlign: "left", fontWeight: "bold" }}>
              <span style={{ fontSize: "1.4rem" }}>Total</span>
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <Typography style={{ textAlign: "right", fontWeight: "bold" }}>
              <span style={{ fontSize: "1.4rem" }}>
                {currency}{" "}
                {displayTotal.toFixed(2)}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    sessionReducer: state.sessionReducer || {},
    reducer: state.customerReducer || {},
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addTip: (tip) => {
      dispatch(addTip(tip));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CartAmount);
